export default __webpack_public_path__ + "static/icons-1414aa76d0504392039c5c46605203d0.png";